import { getAreaTree } from '@/api/system/area'

/** 运行时区域树（来自 extra_area / 华住同步），结构与旧静态省市区兼容：{ code, name, children } */
export let chinaArea = []

let loadPromise = null

function mapNode (node) {
  const code = node.areaId != null ? String(node.areaId) : String(node.areaCode || '')
  const children = (node.children || []).map(mapNode)
  return {
    code,
    name: node.areaName || node.name || '',
    fullName: node.fullName || '',
    areaCode: node.areaCode || '',
    children: children.length ? children : undefined
  }
}

export function loadChinaArea (force) {
  if (!force && chinaArea.length) return Promise.resolve(chinaArea)
  if (!force && loadPromise) return loadPromise
  loadPromise = getAreaTree().then(res => {
    chinaArea = (res.data || []).map(mapNode)
    loadPromise = null
    return chinaArea
  }).catch(err => {
    loadPromise = null
    throw err
  })
  return loadPromise
}

export function findRegionPath (code, roots) {
  if (code == null || code === '') return []
  const target = String(code)
  const walk = (nodes, trail) => {
    for (let i = 0; i < (nodes || []).length; i++) {
      const node = nodes[i]
      const next = trail.concat(node)
      if (String(node.code) === target) return next
      const found = walk(node.children, next)
      if (found) return found
    }
    return null
  }
  return walk(roots || chinaArea, []) || []
}

export function regionLabel (code) {
  return findRegionPath(code).map(node => node.name).join(' / ')
}

/** 是否无下级（运营/运费规则已支持任选一级，保存不再强制末级） */
export function isRegionLeaf (code) {
  const path = findRegionPath(code)
  const node = path[path.length - 1]
  return !!(node && !(node.children && node.children.length))
}

export function regionSubtreeIds (code) {
  const path = findRegionPath(code)
  const node = path[path.length - 1]
  if (!node) return []
  const ids = []
  const walk = current => {
    ids.push(String(current.code))
    ;(current.children || []).forEach(walk)
  }
  walk(node)
  return ids
}
